import Client from './client';

export default class PaymentRedirects extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(id, options = {}) {
    return this.makeRequest(`${this.host}/payment/redirects/${id}`, options);
  }

  post(id, options = {}) {
    return this.makeRequest(`${this.host}/payment/redirects/${id}`, {
      ...options,
       method: 'POST',
    });
  }

}
